
/**
 * 入口文件
 */

/** 样式表 */
import './fonts/fonts.css';
import './styles/app.scss';

import Vue from 'vue';

import App from './App.vue';
import getRouter from './router';
import store from './store';
import i18n from './plugins/i18n';
import {
  picFilter,
  dateFilter,
  substrFilter,
  coverSnToString,
  productUrlFilter,
  newsUrlFilter,
} from '@/filter/index';
import { getLang } from './util/lang';

import './plugins/element';
import './plugins/lazyload.ts';

import './directive/index.ts';

// router
const router = getRouter(store);

// 国际化
// 优先级: localStorage > 浏览器 > default: en
const lang = window.localStorage.getItem('lang') || getLang();

store.commit('setLang', lang);
i18n.locale = lang;

Vue.filter('picFilter', picFilter);
Vue.filter('dateFilter', dateFilter);
Vue.filter('substrFilter', substrFilter);
Vue.filter('coverSnToString', coverSnToString);
Vue.filter('productUrlFilter', productUrlFilter);
Vue.filter('newsUrlFilter', newsUrlFilter);

// 关闭生产模式下给出的提示
Vue.config.productionTip = false;



new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
